export function flipArray(arr: number[]): number[] {
  const result: number[] = [];
  const negativeOneIndices: number[] = [];
  for (let i = 0; i < arr.length; i++) {
    if (arr[i] === -1) {
      negativeOneIndices.push(i);
    }
  }
  const nonNegativeOneElements = arr.filter((elem) => elem !== -1).reverse();
  for (let i = 0, j = 0; i < arr.length; i += 1) {
    if (negativeOneIndices.includes(i)) {
      result.push(-1);
    } else {
      result.push(nonNegativeOneElements[j]!);
      j += 1;
    }
  }
  return result;
}

/** Get the element at `arr[arr.length - count]` */
export function itemLast<T>(arr: T[], count: number): T {
  return arr[arr.length - count]!;
}
